import { addClearPatientFee, removeClearPatientFee } from "helpers/fee";
import { centsToDollars, dollarsToCents } from "helpers/price";

interface IProviderRemaining {
  providerId: string;
  remainingAmountInCents: number;
}

/**
 * The amount (in dollars) the provider should be reduced BY.
 * Cash/Check carry no Clear Patient Fee, so the provider is reduced by the full
 * amount (100%). Financing (CareCredit) is reduced by the amount left after
 * removing the Clear Patient Fee.
 */
export const getProviderReduceByAmount = (
  paymentAmount: number | null,
  paymentType: string | null,
  clearPatientFeePercentage?: number
): number | null => {
  if (!paymentAmount || !paymentType) return null;
  if (paymentType === "Cash" || paymentType === "Check") return paymentAmount;
  return removeClearPatientFee(paymentAmount, clearPatientFeePercentage);
};

/**
 * New total remaining (in cents) after reducing the providers' remaining by
 * reduceByAmount, with the clear fee re-applied, mirroring
 * RemainingAmountEditTable.updatedRemainingTotal.
 */
export const getReducedRemainingInCents = ({
  reduceByAmount,
  paymentPlanRemaining,
  clearFeePercentage,
  isGFE,
  clearPatientFeePercentage,
}: {
  reduceByAmount: number;
  paymentPlanRemaining?: IProviderRemaining[];
  clearFeePercentage: number;
  isGFE: boolean;
  clearPatientFeePercentage?: number;
}): number => {
  const reductionInCents = dollarsToCents(reduceByAmount);
  const currentSubtotal = (paymentPlanRemaining || []).reduce(
    (sum, r) => sum + r.remainingAmountInCents,
    0
  );
  const newSubtotal = currentSubtotal - reductionInCents;

  if (isGFE && clearPatientFeePercentage && clearPatientFeePercentage > 0) {
    return dollarsToCents(
      addClearPatientFee(centsToDollars(newSubtotal), clearPatientFeePercentage)
    );
  }
  if (!isGFE && clearFeePercentage) {
    return newSubtotal * (1 + clearFeePercentage / 100);
  }
  return newSubtotal;
};
